import React, { useEffect, useState, useRef } from "react";
import {
  FaGreaterThan,
  FaLessThan,
  FaRegUserCircle,
  FaWpforms,
} from "react-icons/fa";
import { IoMdExit } from "react-icons/io";
import { AiOutlineClose } from "react-icons/ai";
import { TbForms } from "react-icons/tb";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import { HiOutlineUserPlus, HiOutlineUserGroup } from "react-icons/hi2";

import { NavLink, useNavigate } from "react-router-dom";
import { roles } from "../../constants/Roles";
import "./Nav.css";
import { useDispatch, useSelector } from "react-redux";
import { logOut, setProfile, updateProfile } from "../../redux/actions/user";
import { useLazyQuery, useMutation } from "@apollo/client";
import { SINGLE_USER } from "../../GraphQl/Queries";

const Nav = () => {
  const [navOpen, setnavOpen] = useState(false);
  const [role, setRole] = useState(localStorage.getItem("shub-roles"));
  const profile = useSelector((state) => state?.users?.user);
  const navRef = useRef();
  const hamMenuIcon = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleNav = () => {
    setnavOpen(!navOpen);
  };
  const [user, setUser] = useState(null);
  const [getProfile, { error, loading, data }] = useLazyQuery(SINGLE_USER, {
    variables: {
      getUserByIdId: localStorage.getItem("shub-userId"),
    },
    onCompleted: (data) => {
      dispatch(updateProfile(data?.getUserById));
    },
  });
  useEffect(() => {
    let root = document.documentElement;
    let navDescs = document.querySelectorAll(".navDesc");
    let navHeaders = document.querySelectorAll(".navHeader");
    let navMenu = document.querySelector(".navItems");
    let navTop = document.querySelector(".navTop");
    let navFooter = document.querySelector(".navFooter");
    if (window.innerWidth > 600) {
      if (navOpen) {
        root.style.setProperty("--nav-width", "50px");
        navDescs.forEach((navDesc) => (navDesc.style.display = "none"));
        navHeaders.forEach((navDesc) => (navDesc.style.display = "none"));
        navMenu.style.marginLeft = "0";
        navTop.style.visibility = "hidden";
        navFooter.style.visibility = "hidden";
        navRef.current.classList.remove("open");
      } else {
        root.style.setProperty("--nav-width", "300px");
        navDescs.forEach((navDesc) => (navDesc.style.display = "inline-block"));
        navHeaders.forEach(
          (navDesc) => (navDesc.style.display = "inline-block")
        );
        navMenu.style.marginLeft = "40px";
        navTop.style.visibility = "visible";
        navFooter.style.visibility = "visible";
        navRef.current.classList.add("open");
      }
    } else if (window.innerWidth < 600) {
      if (navOpen) {
        root.style.setProperty("--nav-width", 300);

        navRef.current.style.left = 0;
      } else {
        root.style.setProperty("--nav-width", 100);

        navRef.current.style.left = "-100%";
      }
    }
  }, [navOpen, window.innerWidth]);

  useEffect(() => {
    if (profile == null || profile == undefined) getProfile();
  }, [profile]);

  const handleLogout = () => {
    dispatch(logOut());
  };
  return (
    <>
      <div className='navMobileWrapper'>
        <div
          className='d-flex align-items-center justify-content-start '
          style={{ paddingTop: "2%", gap: "0 10px" }}
        >
          <img
            src={process.env.PUBLIC_URL + "/logo.png"}
            style={{ width: "auto", height: "40px" }}
            alt='survey logo'
          />
          <span className='authWrapperTitle'>SurveyHub</span>
        </div>
        <div
          className='hamburgerMenuIcon'
          ref={hamMenuIcon}
          onClick={toggleNav}
        >
          {navOpen ? <AiOutlineClose /> : <GiHamburgerMenu />}
        </div>
      </div>
      <section className='navBarWrapper ' ref={navRef}>
        <div className='togglerButton' onClick={toggleNav}>
          {navOpen ? <FaGreaterThan /> : <FaLessThan />}
        </div>
        <div className='navTop'>Dashboard</div>
        <div className='navDetailsWrapper flex-col content-between'>
          <div className='navMenu'>
            <div className='navHeader'>Menu</div>
            <div className='navItems'>
              <NavLink
                to='profile'
                onClick={() => {
                  if (window.innerWidth < 640) toggleNav();
                }}
              >
                <span className='navIcon'>
                  <FaRegUserCircle />
                </span>
                <span className='navDesc'> &nbsp; Profile</span>
              </NavLink>
              {role === roles.SUPER_ADMIN && (
                <>
                  <NavLink
                    to='create-admins'
                    onClick={() => {
                      if (window.innerWidth < 640) toggleNav();
                    }}
                  >
                    <span className='navIcon'>
                      <HiOutlineUserPlus />
                    </span>
                    <span className='navDesc'> &nbsp; Create Admins</span>
                  </NavLink>

                  <NavLink
                    to='manage-admins'
                    onClick={() => {
                      if (window.innerWidth < 640) toggleNav();
                    }}
                  >
                    <span className='navIcon'>
                      <HiOutlineUserGroup />
                    </span>
                    <span className='navDesc'> &nbsp; Manage Users</span>
                  </NavLink>

                  <NavLink
                    to='form-requests'
                    onClick={() => {
                      if (window.innerWidth < 640) toggleNav();
                    }}
                  >
                    <span className='navIcon'>
                      <HiOutlineUserGroup />
                    </span>
                    <span className='navDesc'> &nbsp; Surveyor Forms</span>
                  </NavLink>
                </>
              )}
              {(role === roles.ADMIN || role === roles.SUPER_ADMIN) && (
                <>
                  <NavLink
                    to='manage-form'
                    onClick={() => {
                      if (window.innerWidth < 640) toggleNav();
                    }}
                  >
                    <span className='navIcon'>
                      <FaWpforms />
                    </span>
                    <span className='navDesc'> &nbsp; Manage Forms</span>
                  </NavLink>
                  <NavLink
                    to='create-form'
                    onClick={() => {
                      if (window.innerWidth < 640) toggleNav();
                    }}
                  >
                    <span className='navIcon'>
                      <TbForms />
                    </span>
                    <span className='navDesc'> &nbsp; Create Form</span>
                  </NavLink>
                </>
              )}

              {role === roles.SURVEYOR && (
                <>
                  <NavLink
                    to='request-form'
                    onClick={() => {
                      if (window.innerWidth < 640) toggleNav();
                    }}
                  >
                    <span className='navIcon'>
                      <TbForms />
                    </span>
                    <span className='navDesc'> &nbsp; Request Form</span>
                  </NavLink>

                  <NavLink
                    to='manage-form'
                    onClick={() => {
                      if (window.innerWidth < 640) toggleNav();
                    }}
                  >
                    <span className='navIcon'>
                      <MdOutlineDocumentScanner />
                    </span>
                    <span className='navDesc'> &nbsp; My Forms</span>
                  </NavLink>
                </>
              )}
            </div>
          </div>
          <div className='navFooter'>
            <div className='navHeader'>Profile</div>
            <div className='navProfile flex items-center content-start'>
              <div className='profileImageWrapper'>
                <img
                  src={
                    "https://avatars.dicebear.com/api/open-peeps/" +
                    profile?.fullName +
                    ".svg"
                  }
                  className='profileImage'
                />
              </div>
              <div className='profileDetails'>
                <div className='profileName'>
                  {loading
                    ? "Loading..."
                    : profile?.user?.fullName == undefined
                    ? profile?.fullName?.split(" ")[0]
                    : profile?.user?.fullName?.split(" ")[0]}

                  {/* {profile?.user?.fullName?.split(" ")[0] +
                    " " +
                    profile?.user?.fullName?.split(" ")[1]?.charAt(0) +
                    "."} */}
                </div>
                <div className='profileRole'>{role}</div>
              </div>
            </div>

            <div className='logOutBtn flex items-center content-center'>
              <button
                className='flex items-center content-center'
                onClick={handleLogout}
              >
                <IoMdExit />
                <span className='navDesc'> Log Out</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Nav;
